import { useEffect } from "react";

import MainLayout from "../components/Layout/MainLayout";
import GuestLayout from "../components/Layout/GuestLayout";

const InvestorCharter = () => {
  useEffect(() => {
    document.body.classList.add("main-layout");
  }, []);
  return (
    <GuestLayout>
      <section className="privacy-policy-section" style={{ paddingTop: 30 }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2>Investor Charter in respect of Investment Adviser (IA)</h2>
            </div>
            <div className="col-md-12">
              <h4 className="fw-bold"> A. Vision and Mission Statements for investors</h4>
              <b>Vision</b>
              <p>Invest with knowledge &amp; safety.</p>
              <b>Mission</b>
              <p>
                Every investor should be able to invest in right investment products based on their needs,
                manage and monitor them to meet their goals, access reports and enjoy financial wellness.
              </p>
              <h4 className="fw-bold">
                B. Details of business transacted by the Investment Adviser with respect to the investors.
              </h4>
              <ol>
                <li>
                  To enter into an agreement with the client providing all details including fee details, aspects
                  of Conflict of interest disclosure and maintaining confidentiality of information.
                </li>
                <br />
                <li>
                  To do a proper and unbiased risk - profiling and suitability assessment of the client.
                </li>
                <br />
                <li>To conduct audit annually.</li>
                <br />
                <li>To disclose the status of complaints in its website.</li>
                <br />
                <li>
                  To disclose the name, proprietor name, type of registration, registration number, validity,
                  complete address with telephone numbers and associated SEBI Office details (i.e. Head
                  office/ regional/ local Office) on its website.
                </li>
                <br />
                <li>To employ only qualified and certified employees.</li>
                <br />
                <li>To deal with clients only from official number</li>
                <br />
                <li>
                  To maintain records of interactions, with all clients
                  including prospective clients (prior to onboarding), where any
                  conversation related to advice has taken place.
                </li>
                <br />
                <li>
                  To ensure that all advertisements are in adherence to the provisions of the Advertisement
                  Code for Investment Advisers.
                </li>
                <br />
                <li>
                  Not to discriminate in terms of services provided, among clients opting for same/similar
                  products/services offered by investment adviser.
                </li>
                <br />
              </ol>
              <h4 className="fw-bold">
                C. Details of services provided to investors (No Indicative
                Timelines)
              </h4>
              <ol>
                <li>Onboarding of Clients</li>
                <ul>
                  <li>Sharing of agreement copy</li>
                  <li>Completing KYC of clients</li>
                </ul>
                <br />
                <li>Disclosure to Clients</li>
                <ul>
                  <li>
                    To provide full disclosure about its business, affiliations,
                    compensation in the agreement.
                  </li>
                  <li>
                    To not access client’s accounts or holdings for offering
                    advice.
                  </li>
                  <li>To disclose the risk profile to the client.</li>
                  <li>To disclose any conflict of interest of the investment advisory activities with any other
                    activities of the investment adviser.</li>
                  <li>To disclose the extent of use of Artificial Intelligence tools in providing investment
                    advisory services.</li>
                </ul>
                <br />
                <li>
                  To provide investment advice to the client based on the risk-profiling of the clients and
                  suitability of the client.
                </li>
                <br />
                <li>
                  To treat all advisory clients with honesty and integrity.
                </li>
                <br />
                <li>
                  To make adequate disclosure to the investor of all material facts such as risks, obligations,
                  costs, etc. relating to the products or securities advised by the adviser.
                </li>
                <br />
                <li>
                  To provide clear guidance and adequate caution notice to clients when providing
                  investment advice for dealing in complex and high-risk financial products/services.
                </li>
                <br />
                <li>
                  To ensure confidentiality of information shared by clients unless such information is
                  required to be provided in furtherance of discharging legal obligations or a client has
                  provided specific consent to share such information.
                </li>
                <br />
                <li>
                  To disclose the timelines for the various services provided by the investment adviser to
                  clients and ensure adherence to the said timelines.
                </li>
                <br />
              </ol>
              <h4 className="fw-bold">
                D. Details of grievance redressal mechanism and how to access it
              </h4>

              <ol>
                <li>
                  Investor can lodge complaints/grievances against an Investment Adviser in the following ways:
                  <br /><br />
                  <u>Mode of filing the complaint with the Investment Adviser:</u><br />
                  In case of any grievance or complaint, an investor may approach the concerned Investment Adviser,
                  who shall strive to redress the grievance immediately, but not later than 21 days from the receipt of the grievance.
                  <br /><br />
                  <u>Mode of filing the complaint on SCORES or with the Investment Adviser Administration and Supervisory Body (IAASB):</u>
                  <ol type="i">
                    <li>
                      SCORES 2.0 (a web based centralized grievance redressal system of SEBI for
                      facilitating effective grievance redressal in time-bound manner){" "}
                      <a
                        style={{ color: "royalblue" }}
                        href="https://scores.sebi.gov.in"
                        target="_blank"
                      >
                        https://scores.sebi.gov.in
                      </a>{" "}
                      <br />
                      Two level review for complaint/grievance against investment adviser:
                      <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                        <li>First review done by designated body (IAASB)</li>
                        <li>Second review done by SEBI</li>
                      </ul>
                    </li>
                    <li>
                      Email to designated email ID of IAASB
                    </li>
                  </ol>
                </li>

                <br />

                <li>
                  If the investor is not satisfied with the resolution provided by the Investment Adviser or Market Participant,
                  the investor may file the complaint on the SMART ODR platform for resolution through online conciliation or arbitration.
                </li>

                <br />

                <li>
                  For physical complaints, investors may send their written complaints to:
                  <br /><br />
                  Office of Investor Assistance and Education<br />
                  Securities and Exchange Board of India (SEBI),<br />
                  SEBI Bhavan, Plot No. C4-A, ‘G’ Block,<br />
                  Bandra-Kurla Complex, Bandra (E),<br />
                  Mumbai – 400 051.
                </li>
              </ol>
              <h4 className="fw-bold">
                E. Rights of Investors
              </h4>

              <ol style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li>Right to Privacy and Confidentiality</li>
                <li>Right to Transparent Practices</li>
                <li>Right to Fair and Equitable Treatment</li>
                <li>Right to Adequate Information</li>
                <li>
                  Right to Initial and Continuing Disclosure
                  <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                    <li>Right to receive information about all the statutory and regulatory disclosures.</li>
                  </ul>
                </li>
                <li>Right to Fair &amp; True Advertisement</li>
                <li>Right to Awareness about Service Parameters and Turnaround Times</li>
                <li>Right to be informed of the timelines for each service</li>
                <li>Right to be Heard and Satisfactory Grievance Redressal</li>
                <li>Right to have timely redressal</li>
                <li>Right to Suitability of the Financial Products</li>
                <li>
                  Right to Exit from financial product or service in accordance with the terms of agreement
                  with the Investment Adviser
                </li>
                <li>
                  Right to receive clear guidance and caution notice when dealing in Complex and High-Risk
                  Financial Products and Services
                </li>
                <li>
                  Additional Rights to Vulnerable Consumers
                  <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                    <li>Right to get access to services in a suitable manner even if differently abled</li>
                  </ul>
                </li>
                <li>Right to provide feedback on the financial products and services used</li>
                <li>Right against coercive, unfair, and one-sided clauses in financial agreements</li>
              </ol>

              <h4 className="fw-bold">
                F. Expectations from the investors (Responsibilities of
                investors)
              </h4>
              <p>  <b>Do’s</b></p>
              <ol>
                <li>Always deal with SEBI registered Investment Advisers.</li>
                <br />
                <li>
                  Ensure that the Investment Adviser has a valid registration
                  certificate.
                </li>{" "}
                <br />
                <li>
                  Check for SEBI registration number. Please refer to the list
                  of all SEBI registered Investment Advisers which is available
                  on SEBI website in the following link:{" "}
                  <a
                    style={{ color: "royalblue" }}
                    href="https://www.sebi.gov.in/sebiweb/other/OtherAction.do?doRecognisedFpi=yes&intmld=13"
                    target="_blank"
                  >
                    https://www.sebi.gov.in/sebiweb/other/OtherAction.do?doRecognisedFpi=yes&amp;intmld=13{" "}
                  </a>{" "}
                </li>{" "}
                <br />
                <li>
                  Pay only advisory fees to your Investment Adviser. Make payments of advisory fees
                  through banking channels only and maintain duly signed receipts mentioning the
                  details of your payments.
                  You may make payment of advisory fees through Centralised Fee Collection
                  Mechanism (CeFCoM) of IAASB if investment adviser has opted for the mechanism.
                </li>{" "}
                <br />
                <li>
                  Always ask for your risk profiling before accepting investment advice. Insist that
                  Investment Adviser provides advisory strictly on the basis of your risk profiling and
                  take into account available investment alternatives.
                </li>{" "}
                <br />
                <li>
                  Ask all relevant questions and clear your doubts with your
                  Investment Adviser before acting on advice.
                </li>{" "}
                <br />
                <li>
                  Assess the risk–return profile of the investment as well as
                  the liquidity and safety aspects before making investments.
                </li>{" "}
                <br />
                <li>
                  Insist on getting the terms and conditions in writing duly signed and stamped. Read
                  these terms and conditions carefully particularly regarding advisory fees, advisory
                  plans, category of recommendations etc. before dealing with any Investment Adviser.
                </li>{" "}
                <br />
                <li>Be vigilant in your transactions.</li> <br />
                <li>
                  Approach the appropriate authorities for redressal of your
                  doubts / grievances.
                </li>{" "}
                <br />
                <li>
                  Inform SEBI about Investment Advisers offering assured or
                  guaranteed returns.
                </li>{" "}
                <br />
                <li>
                  Always be aware that you have the right to exit the service of an Investment Adviser.
                </li>{" "}
                <br />
                <li>
                  Always be aware that you have the right to seek clarifications and clear guidance on
                  advice.
                </li>{" "}
                <br />
                <li>
                  Always be aware that you have the right to provide feedback to the Investment Adviser
                  in respect of services received.
                </li>{" "}
                <br />
                <li>
                  Always be aware that you will not be bound by any clause, prescribed by the
                  investment adviser, which is contravening any regulatory provisions.
                </li>{" "}
                <br />
              </ol>
              <p>  <b>Don’ts</b></p>
              <ol>
                <li>
                  Don’t fall for stock tips offered under the pretext of
                  investment advice.
                </li>{" "}
                <br />
                <li>
                  Do not provide funds for investment to the Investment Adviser.
                </li>{" "}
                <br />
                <li>
                  Don’t fall for the promise of indicative or exorbitant or
                  assured returns by the Investment Advisers. Don’t let greed
                  overcome rational investment decisions.
                </li>{" "}
                <br />
                <li>
                  Don’t fall prey to luring advertisements or market rumors.
                </li>{" "}
                <br />
                <li>
                  Avoid doing transactions only on the basis of phone calls or
                  messages from any Investment adviser or its representatives.
                </li>{" "}
                <br />
                <li>
                  Don’t take decisions just because of repeated messages and
                  calls by Investment Advisers.
                </li>{" "}
                <br />
                <li>
                  Do not fall prey to limited period discount or other
                  incentive, gifts, etc. offered by Investment advisers.
                </li>{" "}
                <br />
                <li>
                  Don’t rush into making investments that do not match your risk
                  taking appetite and investment goals.
                </li>{" "}
                <br />
                <li>
                  Do not share login credential and password of your trading and
                  demat accounts with the Investment Adviser.
                </li>{" "}
                <br />
              </ol>
            </div>
          </div>
        </div>
      </section>
    </GuestLayout>
  );
};
export default InvestorCharter;
